import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchVendorById,
  updateVendor,
  clearVendorState,
} from "../redux/slices/vendorSlice";
import Swal from "sweetalert2";
import { Link, useParams } from "react-router-dom";
import VendorReviews from "./VendorReviews";

const VendorProfile = ({  }) => {

  const { vendorProfileId } = useParams();
  console.log("vendorProfileId", vendorProfileId)

  const dispatch = useDispatch();
  const { vendor, loading, successMessage, errorMessage } = useSelector(
    (state) => state.vendor
  );
  const { user } = useSelector((state) => state.auth);
  const userId = user?.vendor?._id ? user?.vendor?._id : vendorProfileId

  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    serviceName: "",
    experience: "",
    address: "",
  });

  useEffect(() => {
    dispatch(fetchVendorById(userId));
  }, [dispatch, userId]);

  // Load data into form when profile arrives
  useEffect(() => {
    if (vendor) {
      setForm({
        fullName: vendor.user?.name || "",
        phone: vendor.contactNumber || "",
        serviceName: vendor.serviceName || "",
        experience: vendor.workExperience || "",
        address: vendor.address || "",
      });
    }
  }, [vendor]);

  // SweetAlert Messages
  useEffect(() => {
    if (successMessage) {
      Swal.fire("Success", successMessage, "success");
      dispatch(clearVendorState());
      setEditMode(false);
    }
    if (errorMessage) {
      Swal.fire("Error", errorMessage, "error");
      dispatch(clearVendorState());
    }
  }, [successMessage, errorMessage, dispatch]);

  // Submit Update
  const handleSubmit = () => {
    const formData = new FormData();
    Object.keys(form).forEach((key) => formData.append(key, form[key]));

    dispatch(updateVendor({ id: vendor._id, formData }));
  };

  if (loading || !vendor) return <p className="text-center mt-4">Loading...</p>;

  return (

    <div className="container mt-4">


      <div className="card shadow-lg border-0">

        <div className="card-header">
          <h5 className="mb-0">My Profile</h5>
        </div>

        <div className="row g-0">

          {/* LEFT SIDE PROFILE IMAGE */}
          <div className="col-md-4 text-center bg-light p-4">
            <img
              src={vendor.shopImage}
              alt="Profile"
              className="img-fluid rounded"
              style={{ height: "230px", objectFit: "cover" }}
            />
            <h4 className="mt-3">{vendor.ownerName}</h4>
            <span className={`badge ${vendor.isApproved ? "bg-success" : "bg-warning text-dark"}`}>
              {vendor.isApproved ? "Verified" : "Pending Verification"}
            </span>
            <hr />

            <span>
              {vendor.about}
            </span>

          </div>

          {/* RIGHT SIDE DETAILS */}
          <div className="col-md-8 p-4">

            {!editMode ? (
              <>

                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">My Profile Details</h5>

                    <Link to={`/edit-vendor-profile/${vendor?._id}`} className="btn btn-sm bg-dark text-white" >
                      Edit Profile
                    </Link>

                  </div>

                  <div className="card-body">


                    <table className="table table-sm table-bordered">
                      <tbody>
                        <tr>
                          <th>Shop Name</th>
                          <td>{vendor.shopName}</td>
                        </tr>
                        <tr>
                          <th>Full Name</th>
                          <td>{vendor.ownerName}</td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{user?.email}</td>
                        </tr>
                        <tr>
                          <th>Personal Number</th>
                          <td>{vendor?.mobile}</td>
                        </tr>

                        <tr>
                          <th>WhatsApp Number</th>
                          <td>{vendor?.whatsappNumber}</td>
                        </tr>

                        <tr>
                          <th>Service</th>
                          <td>
                            {vendor?.category?.map((cat) => (
                              <div key={cat._id} className="badge bg-success gap-3" style={{ gap: 10 }}>
                                <a>{cat.name}</a>
                              </div>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <th>Experience</th>
                          <td>{vendor.workExperience} Years</td>
                        </tr>
                        <tr>
                          <th>Location</th>
                          <td>{vendor.city}, {vendor.state}, {vendor.address}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>


              </>
            ) : (
              <>
                <h5 className="mb-3">Edit Profile</h5>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.fullName}
                      onChange={(e) => setForm({ ...form, fullName: e.target.value })}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Service Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.serviceName}
                      onChange={(e) => setForm({ ...form, serviceName: e.target.value })}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Experience (Years)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.experience}
                      onChange={(e) => setForm({ ...form, experience: e.target.value })}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={form.address}
                      onChange={(e) => setForm({ ...form, address: e.target.value })}
                    ></textarea>
                  </div>

                  <div className="d-flex gap-2 mt-3">
                    <button className="btn btn-success" onClick={handleSubmit}>
                      Save Changes
                    </button>
                    <button className="btn btn-secondary" onClick={() => setEditMode(false)}>
                      Cancel
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <VendorReviews vendorId={vendor._id} />



    </div>
  );
};

export default VendorProfile;
